import React from 'react';
import musicTrack from './audio/we_are_dicks.mp3';
import {autoPlayMusic} from './constants';
import {FaVolumeMute, FaVolumeUp} from 'react-icons/fa';
import {VolumeButton} from './App.styles';

export default class MusicPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.audio = new Audio(musicTrack);
        this.state = {};
        this.audio.autoplay = true;
        this.audio.loop = true;
        if (!autoPlayMusic) this.audio.volume = 0;
    }

    isPlaying = () => this.audio.volume !== 0;

    togglePlay = () => {
        this.audio.volume = !this.isPlaying() ? 1 : 0;
        this.forceUpdate();
    };

    componentWillUnmount = () => {
        this.audio.pause();
    };

    render = () => (
        <>
            <VolumeButton onClick={this.togglePlay}>
                {this.isPlaying() ? <FaVolumeUp /> : <FaVolumeMute />}
            </VolumeButton>
        </>
    );
}
